export var reduxKey = '@@devpage';
export var actionKey = '@@devpage';
export var defaultState = {
    viewOptions: {
        visiblePanel: false,
        activeActionBar: 'primary',
    },
};
//# sourceMappingURL=constants.js.map